<!-- Trigger button -->
<button type="button" class="btn btn-primary" (click)="openGalleryModal()"><i class="fi fi-rr-gallery"></i> 
    {{ isParonama360 ? 'დაამატე სურათი (360 პრევიუ)' : ' სურათების არჩევა' }}
</button>

<!-- Modal -->
<ng-template #galleryModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      {{ isParonama360 ? 'სურათების არჩევა (360 პრევიუ)' : ' სურათების არჩევა გალერიიდან' }}
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
   <app-file-manager
    [multiselect]="multiselect"
    (multipleFilesSelected)="onSelectionChanged($event)">
  </app-file-manager>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="confirmSelection(modal)">დადასტურება</button>
  </div>

</ng-template>

